import React from 'react';
import './Skeleton.css';

/**
 * Skeleton Loading Components
 * Used for loading states before data arrives
 */

/**
 * Base skeleton element with shimmer animation
 */
export function Skeleton({ width, height, borderRadius = 4, className = '' }) {
  const style = {
    width: width || '100%',
    height: height || '16px',
    borderRadius: borderRadius,
  };

  return <div className={`skeleton ${className}`} style={style} />;
}

/**
 * Skeleton for media cards (video thumbnails)
 */
export function MediaCardSkeleton() {
  return (
    <div className="media-card-skeleton">
      <div className="skeleton-thumb">
        <Skeleton height="100%" borderRadius={0} />
      </div>
      <div className="skeleton-content">
        <Skeleton height="18px" width="90%" />
        <Skeleton height="14px" width="60%" />
        <div className="skeleton-metrics">
          <Skeleton height="14px" width="60px" />
          <Skeleton height="14px" width="60px" />
          <Skeleton height="14px" width="60px" />
        </div>
        <div className="skeleton-tags">
          <Skeleton height="20px" width="50px" borderRadius={4} />
          <Skeleton height="20px" width="60px" borderRadius={4} />
          <Skeleton height="20px" width="45px" borderRadius={4} />
        </div>
        <div className="skeleton-footer">
          <Skeleton height="12px" width="80px" />
          <Skeleton height="12px" width="100px" />
        </div>
      </div>
    </div>
  );
}

/**
 * Skeleton for tag cards
 */
export function TagCardSkeleton() {
  return (
    <div className="tag-card-skeleton">
      <div className="skeleton-header">
        <Skeleton height="24px" width="60%" />
        <Skeleton height="28px" width="70px" borderRadius={8} />
      </div>
      <div className="skeleton-rank">
        <Skeleton height="24px" width="80px" borderRadius={16} />
        <Skeleton height="24px" width="90px" borderRadius={16} />
      </div>
      <div className="skeleton-platforms">
        <Skeleton height="24px" width="100px" borderRadius={12} />
        <Skeleton height="24px" width="80px" borderRadius={12} />
      </div>
      <div className="skeleton-lifecycle">
        <Skeleton height="22px" width="70px" borderRadius={4} />
        <Skeleton height="22px" width="60px" borderRadius={4} />
      </div>
      <Skeleton height="40px" width="100%" borderRadius={8} />
      <div className="skeleton-action">
        <Skeleton height="16px" width="100px" />
      </div>
    </div>
  );
}

/**
 * Grid of media card skeletons
 */
export function MediaGridSkeleton({ count = 6 }) {
  return (
    <div className="media-grid">
      {Array.from({ length: count }).map((_, i) => (
        <MediaCardSkeleton key={i} />
      ))}
    </div>
  );
}

/**
 * Grid of tag card skeletons
 */
export function TagGridSkeleton({ count = 6 }) {
  return (
    <div className="tags-grid">
      {Array.from({ length: count }).map((_, i) => (
        <TagCardSkeleton key={i} />
      ))}
    </div>
  );
}

export default Skeleton;
